export default __webpack_public_path__ + "c491e8eac0e69eb329efe20099c2ca55.jpg";